import { render, staticRenderFns } from "./DetailRecruititEmployee.vue?vue&type=template&id=6b9f716e&"
import script from "./DetailRecruititEmployee.vue?vue&type=script&lang=js&"
export * from "./DetailRecruititEmployee.vue?vue&type=script&lang=js&"
import style0 from "./DetailRecruititEmployee.vue?vue&type=style&index=0&id=6b9f716e&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b9f716e')) {
      api.createRecord('6b9f716e', component.options)
    } else {
      api.reload('6b9f716e', component.options)
    }
    module.hot.accept("./DetailRecruititEmployee.vue?vue&type=template&id=6b9f716e&", function () {
      api.rerender('6b9f716e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home/PageChild/DetailRecruititEmployee.vue"
export default component.exports